import React from "react";
import { styled } from "styled-components";
import Game from "../Components/OtherWork";
import { otherWorks } from "../data";
import { Column } from "../Styles/StyledComponents";

const GamesContainer = styled(Column)`
  gap: 100px;
  padding: 20px;

  @media (max-width: 768px) {
    gap: 40px;
  }
`;

const Seperator = styled.div`
  width: 100%;
  height: 1px;
  background: silver;
  opacity: 0.2;
`;

const OtherWorksPage: React.FC = () => (
  <GamesContainer>
    {otherWorks.map((game, index) => (
      <React.Fragment key={index}>
        <Game game={game} />
        {index !== otherWorks.length - 1 && <Seperator />}
      </React.Fragment>
    ))}
  </GamesContainer>
);


export default OtherWorksPage;
